import * as React from 'react';
import { SVGProps } from 'react';

const IconWellOpenSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 1v2.764L2.882 8 5 12.236V15h2v-3.236L5.118 8 7 4.236V1H5ZM11 1v2.764L13.118 8 11 12.236V15H9v-3.236L10.882 8 9 4.236V1h2Z" />
  </svg>
);
export default IconWellOpenSizeS;
